module.exports = __webpack_public_path__ + "img/video6.cff7ee85.jpg";